import { getLocalURL } from "../../../scripts/helpers/globale"

export default class Navigation {
  constructor(component) {
    this.dom = {
      $component: component,
      $accountPageBtns: document.querySelectorAll('.js-directToAccount')
    }
    this.state = {

    }

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$accountPageBtns.forEach($btn => $btn.addEventListener('click', () => window.location.href = getLocalURL('/account')))
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Navigation = this
  }
}
